/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BalanceHistoryOutput
 */
export interface BalanceHistoryOutput {
    /**
     * Payment account balance
     * @type {number}
     * @memberof BalanceHistoryOutput
     */
    balance?: number;
    /**
     * 
     * @type {Error}
     * @memberof BalanceHistoryOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the BalanceHistoryOutput interface.
 */
export function instanceOfBalanceHistoryOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BalanceHistoryOutputFromJSON(json: any): BalanceHistoryOutput {
    return BalanceHistoryOutputFromJSONTyped(json, false);
}

export function BalanceHistoryOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceHistoryOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'balance': !exists(json, 'balance') ? undefined : json['balance'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function BalanceHistoryOutputToJSON(value?: BalanceHistoryOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'balance': value.balance,
        'error': value.error,
    };
}

